<template>
    <router-link :to="{name: 'video.view', params: {id: this.video.id, slug: this.video.slug}}">
        <b-img-lazy
            fluid
            v-if="thumbnail"
            :src="thumbnail"
            :alt="video.description"
        />
    </router-link>
</template>

<script>
import VideoThumbnailMixin from "../../../mixins/video-infos"
import Spinner from "../Divers/Spinner";

export default {
    name: "VideoLink",
    components: {Spinner},
    mixins: [VideoThumbnailMixin],
    props: {
        video: null,
    },
    mounted() {
        this.getVideoThumbnail(this.video)
    },

}
</script>

